import { useState } from 'react';

interface UseGlobalFilterReturn {
	isShowCanvas: boolean;
	toggleFilter: () => void;
	handleFilterApply: (data: any) => void;
	handleFilterClear: () => void;
	handleFilterCount: (data: any) => number;
	activeFilterCount: number;
}

export const useGlobalFilter = (): UseGlobalFilterReturn => {
	const [isShowCanvas, setIsShowCanvas] = useState(false);
	const [activeFilterCount,setActiveFilterCount] =  useState<any>();

	const toggleFilter = () => {
		setIsShowCanvas(!isShowCanvas);
	};

	const handleFilterApply = (data: any) => {
		toggleFilter();
	};

	const handleFilterClear = () => {
		toggleFilter();
	};

	const handleFilterCount = (data: any) => {
		const advanceFilterCount =	Object.values(data).filter(
			(value) => value !== "" && value !== null && value !== undefined
		  ).length
		  setActiveFilterCount(advanceFilterCount);
		return activeFilterCount;
	}


	return {
		isShowCanvas,
		toggleFilter,
		handleFilterApply,
		handleFilterClear,
		handleFilterCount,
		activeFilterCount
	};
};